var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.293,44l-24.533,0c-2.725,0 -4.941,-2.217 -4.941,-4.941l0,-18.78c0,-2.709 2.19,-4.916 4.941,-4.943l1.491,0l0,-4.56c0,-5.942 4.834,-10.776 10.776,-10.776c5.941,0 10.775,4.833 10.775,10.776l0,4.56l1.492,0c2.725,0 4.941,2.217 4.941,4.942l0,18.781c0,2.724 -2.217,4.941 -4.942,4.941Zm-11.85,-22.582c4.787,0 8.673,3.886 8.673,8.672c0,4.787 -3.886,8.673 -8.673,8.673c-4.786,0 -8.672,-3.886 -8.672,-8.673c0,-4.786 3.886,-8.672 8.672,-8.672Zm5.967,-6.082l0,-4.561c0,-3.519 -2.864,-6.382 -6.383,-6.382c-3.52,0 -6.383,2.863 -6.383,6.382l0,4.561l12.766,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.078e3d02181e21dc0ac844579676392a.svg";
export { ForwardRef as ReactComponent };